import React from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import BannerPage from '../../Components/Banner'
import { Link } from 'react-router'
import DisplayUtilities from './DisplayUtilities'

const Utilities = () => {
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">

            <Sidebar />
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                <TopHeader pageName="Utilities" />
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    <BannerPage pageName={'utilities'} />
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h2 className="text-2xl text-neutral-800">Utilities</h2>
                            <p className="text-neutral-600">Manage concrete project entries and case studies</p>
                        </div>
                        <Link to='/utilities/form' class="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
                            <i className="fa-solid fa-plus mr-2"></i>
                            Add New Utilities
                        </Link>
                    </div>
                    <DisplayUtilities />
                </div>
            </div>
        </div>
    )
}

export default Utilities
